import { render } from "./noticeSearch.vue?vue&type=template&id=59dce6c6&scoped=true"
import script from "./noticeSearch.vue?vue&type=script&lang=js"
export * from "./noticeSearch.vue?vue&type=script&lang=js"

import "./noticeSearch.vue?vue&type=style&index=0&id=59dce6c6&lang=scss&scoped=true"

import exportComponent from "D:\\project\\websites\\zct_v2_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59dce6c6"]])

export default __exports__